import { Button as ANTButton, Skeleton, Empty, Switch, Form, Space, DatePicker, Popconfirm, Modal, notification, Select as AntSelect } from 'antd';
import DynamicDrawer from 'components/drawer';
import React, { useRef, useEffect, useState } from 'react';
import Table from 'components/Table';
import Select from 'components/Atom/Select';
import Input from 'components/Atom/Input';
import moment from 'moment';
import { checkUserPermissions, handleBinConfigByFileData } from '../../../utils/services.js';
import { USER_ROLES } from 'utils/constant.js';
import { Button, ResetButton } from 'components/Atom/Button';
import { Breadcrumbs } from '../../../components/Atom/breadcumbs';
import { PageHeader } from '../../../components/Atom/PageHeader';
import { EditFilled, UploadOutlined, PlusCircleOutlined, MinusCircleOutlined } from '@ant-design/icons';
import { useQuery } from 'react-query';
import SelectStore from 'components/SelectStore';
import CSVBinsModel from './csvBinsModel.jsx';
import { useSelector } from 'react-redux';
import { addBinDiscount, deleteBinDiscount, getAllBinDiscounts, updateBinDiscount, addBinDiscountByCSVFile } from 'api/binDiscounts';
const { RangePicker } = DatePicker;
const RuleEnabledSwitch = ({ value, fetchData }) => {
  const [statusToggle, setStatusToggle] = useState(value?.rule_enabled);
  const [isUpdating, setIsUpdating] = useState(false);
  useEffect(() => {
    setStatusToggle(value?.rule_enabled);
  }, [value?.rule_enabled]);

  const onUpdate = async (statusToggle) => {
    setIsUpdating(true);
    const payload = {
      discount_type: value?.discount_type,
      discount_value: value?.discount_value,
      rule_enabled: statusToggle,
      ...(value?.discount_type === 'percentage' && { discount_limit: value?.discount_limit }),
    };

    const response = await updateBinDiscount(value?.store_id, value?._id, payload);
    if (response?.data?.success) {
      fetchData();
      setStatusToggle(statusToggle);
      setIsUpdating(false);
    }
    setIsUpdating(false);
  };

  return (
    <React.Fragment>
      <div className='custom-switch flex items-center justify-center'>
        <Switch
          size='small'
          checked={statusToggle}
          loading={isUpdating}
          disabled={isUpdating}
          onChange={async () => {
            const newStatusToggle = !statusToggle;
            await onUpdate(newStatusToggle);
          }}
          name='rule_enabled'
        />
        <div className='text-sm font-[550] ml-3'>{statusToggle === true ? 'Enabled' : 'Disabled'}</div>
      </div>
    </React.Fragment>
  );
};
const handelValue = (e) => {
  e.target.value = e.target.value.replace(/[^0-9]/g);
};
export const BinDiscount = () => {
  const [isBinModalOpen, setIsBinModalOpen] = useState(false);
  const [isAddBinFormOpen, setIsAddBinFormOpen] = useState(false);
  // const [store, setStore] = useState(useSelector((state) => state.company.store));
  const store = useSelector((state) => state.company.store);
  const [binModalData, setBinModalData] = useState({});
  const [statusToggle, setStatusToggle] = useState(false);
  const [addStatusToggle, setAddStatusToggle] = useState(true);
  const [discountType, setDiscountType] = useState(binModalData?.discount_type);
  const [addBinDiscountType, setAddBinDiscountType] = useState('percentage');
  const [isBinAdding, setIsBinAdding] = useState(false);
  const [isBinDeleting, setIsBinDeleting] = useState(false);
  const [isBinUpdating, setIsBinUpdating] = useState(false);
  const [discountDateRange, setDiscountRange] = useState([]);
  const [binConfigType, setBinConfigType] = useState('manually');
  const hiddenFileInput = useRef(null);
  const [selectedCSVFile, setSelectedCSVFile] = useState(null);
  const [deleteBinModal, setDeleteBinModal] = useState(false);
  const [binStoreId, setBinStoreId] = useState(null);
  const [openConfiguredBinsDetailModel, setOpenConfiguredBinsDetailModel] = useState(false);
  const [configuredBinsDetailData, setConfiguredBinsDetailData] = useState(null);
  const [queryParams, setQueryParams] = useState({
    offset: 0,
    limit: 20,
    currentPage: 1,
  });

  const handleCloseModal = () => {
    setIsBinModalOpen(false);
    setIsAddBinFormOpen(false);
    setBinModalData({});
    setDiscountType('percentage');
    setIsBinAdding(false);
    setAddBinDiscountType('percentage');
    setAddStatusToggle(true);
    setSelectedCSVFile(null);
    setBinConfigType('manually');
  };
  const handleAddCloseModal = () => {
    setIsAddBinFormOpen(false);
    setBinModalData({});
    setDiscountType('percentage');
    setIsBinAdding(false);
    setAddBinDiscountType('percentage');
    setAddStatusToggle(true);
    setSelectedCSVFile(null);
    setBinConfigType('manually');
  };
  const handleEditCloseModal = () => {
    setIsBinModalOpen(false);
    setBinModalData({});
    setDiscountType('percentage');
    setIsBinAdding(false);
    setAddBinDiscountType('percentage');
    setAddStatusToggle(true);
    setSelectedCSVFile(null);
    setBinConfigType('manually');
  };
  const handleDeleteBin = async (id) => {
    setIsBinDeleting(true);
    const response = await deleteBinDiscount(store?._id, id);
    if (response?.data?.success) {
      resetTableSetting();
      handleCloseModal();
      setDeleteBinModal(false);
    }
    setIsBinDeleting(false);
  };
  const fetchBINData = async (paramsData) => {
    const params = { offset: paramsData?.offset, limit: paramsData?.limit };
    const response = await getAllBinDiscounts(store?._id, params);
    return response?.data;
  };
  const { data, refetch, isLoading, isRefetching } = useQuery('binDiscount', () => fetchBINData(queryParams), {
    enabled: false,
    manual: true,
  });
  useEffect(() => {
    refetch();
  }, [queryParams, store]);
  const handlePagination = (page, pageSize) => {
    if (queryParams.limit !== pageSize) {
      setQueryParams({ limit: pageSize, offset: 0, currentPage: 1 });
    } else {
      const countOffset = page * queryParams.limit - queryParams.limit;
      setQueryParams({ limit: pageSize, offset: countOffset, currentPage: page });
    }
  };
  const handleDiscountRangeFormat = (range) => {
    if (range?.length > 0) {
      let start_date = new Date(range[0]);
      let end_date = new Date(range[1]);
      start_date.setUTCHours(0, 0, 0, 0);
      end_date.setUTCHours(23, 59, 0, 0);
      return { start_date: start_date, end_date: end_date };
    } else {
      return { start_date: null, end_date: null };
    }
  };
  const handleDiscountDateRange = (range) => {
    setDiscountRange(range);
  };
  const handleOnStoreChange = (e) => {
    setStore(e);
    resetTableSetting();
  };
  const initialValues = {
    rule_enabled: binModalData?.rule_enabled || false,
    id: binModalData?.id,
    discount_type: discountType || 'percentage',
    discount_limit: String(binModalData?.discount_limit ?? ''),
    discount_value: String(binModalData?.discount_value ?? ''),
    date_range: [binModalData?.start_date ? moment(binModalData?.start_date).utc() : null, binModalData?.end_date ? moment(binModalData?.end_date).utc() : null],
    on_discounted_items: binModalData?.on_discounted_items || false,
    minimum_order_value: String(binModalData?.minimum_order_value ?? ''),
    active_days: binModalData?.active_days ? binModalData.active_days.split(',').map((d) => d.trim()) : [],
    usage_limits: [
      ...(binModalData?.max_daily_usage ? [{ interval: 'daily', max_usage: String(binModalData.max_daily_usage) }] : []),
      ...(binModalData?.max_monthly_usage ? [{ interval: 'monthly', max_usage: String(binModalData.max_monthly_usage) }] : []),
    ],
  };
  const columnsData = [
    {
      title: '#',
      render: (text, record, index) => (queryParams?.currentPage - 1) * queryParams?.limit + (index + 1),
      key: 'index',
    },
    {
      title: 'BIN',
      render: (value, index) => <React.Fragment key={index}>{value?.bin}</React.Fragment>,
      key: 'bin',
    },
    {
      title: 'Bank Logo',
      render: (value, index) => {
        return <img key={index} className='h-[26px] w-[102px]' src={value?.bank_logo} alt='icon' />;
      },
      key: 'bank_logo',
    },
    {
      title: 'Discount Type',
      render: (value, index) => (
        <div key={index} className='capitalize'>
          {value?.discount_type}
        </div>
      ),
      key: 'discount_type',
    },
    {
      title: 'Value',
      render: (value, index) => <React.Fragment key={index}>{value?.discount_value}</React.Fragment>,
      key: 'value',
    },
    {
      title: 'MOV',
      render: (value, index) => <React.Fragment key={index}>{value?.minimum_order_value || '-'}</React.Fragment>,
      key: 'minimum_order_value',
    },
    {
      title: 'Discount Days',
      render: (value, index) => <React.Fragment key={index}>{value?.active_days?.split?.(',')?.length || '-'}</React.Fragment>,
      key: 'active_days',
    },
    {
      title: 'Daily Frequency',
      render: (value, index) => <React.Fragment key={index}>{value?.max_daily_usage || '-'}</React.Fragment>,
      key: 'max_daily_usage',
    },
    {
      title: 'Monthly Frequency',
      render: (value, index) => <React.Fragment key={index}>{value?.max_monthly_usage || '-'}</React.Fragment>,
      key: 'max_monthly_usage',
    },
    ...(checkUserPermissions([USER_ROLES.XPAY_ADMIN, USER_ROLES.XPAY_RESTRICTED_ADMIN])
      ? [
          {
            title: 'BIN Status',
            render: (value) => <RuleEnabledSwitch value={value} fetchData={refetch} />,
            key: 'rule_enabled',
          },
          // {
          //   title: 'Discount Applicable Between',
          //   render: (value, index) => (
          //     <React.Fragment key={index}>
          //       {value?.start_date && value?.end_date ? (
          //         <>
          //           {moment(value?.start_date).utc().format('LL')} - {moment(value?.end_date).utc().format('LL')}{' '}
          //         </>
          //       ) : (
          //         'Not Applied'
          //       )}
          //     </React.Fragment>
          //   ),
          //   key: 'value',
          // },
          {
            title: 'Action',
            key: 'action',
            render: (data, index) => {
              return (
                <div key={index} className='flex items-center gap-2'>
                  <div
                    className='table-action-btn w-[56px] flex items-center justify-center'
                    onClick={() => {
                      setBinModalData(data);
                      // setStatusToggle(data?.rule_enabled);
                      setDiscountType(data?.discount_type);
                      setIsBinModalOpen(true);
                    }}
                    style={{ cursor: 'pointer' }}>
                    Edit
                  </div>
                  <div
                    type='primary'
                    className='table-action-btn'
                    onClick={() => {
                      setBinStoreId(data?._id);
                      setDeleteBinModal(true);
                    }}
                    style={{ cursor: 'pointer' }}>
                    Delete
                  </div>
                </div>
              );
            },
          },
        ]
      : []),
  ];

  const options = [
    {
      label: 'Percentage',
      value: 'percentage',
    },
    {
      label: 'Value',
      value: 'value',
    },
  ];
  const fileUploadOptions = [
    {
      label: 'Manually',
      value: 'manually',
    },
    {
      label: 'By File',
      value: 'csv',
    },
  ];

  const onUpdateSubmit = async (value) => {
    // const { start_date, end_date } = handleDiscountRangeFormat(discountDateRange);
    setIsBinUpdating(true);
    const payload = {
      discount_type: discountType,
      discount_value: value?.discount_value,
      // start_date: start_date,
      // end_date: end_date,
      id: value?.id,
      rule_enabled: value?.rule_enabled,
      ...(discountType === 'percentage' && { discount_limit: value?.discount_limit }),
      minimum_order_value: value?.minimum_order_value,
      active_days: value?.active_days?.length > 0 ? value.active_days.join(',') : null,
      max_daily_usage: value?.usage_limits?.find((l) => l?.interval === 'daily')?.max_usage || null,
      max_monthly_usage: value?.usage_limits?.find((l) => l?.interval === 'monthly')?.max_usage || null,
    };

    const response = await updateBinDiscount(store?._id, binModalData?._id, payload);
    if (response?.data?.success) {
      refetch();
      handleCloseModal();
    }
    setIsBinUpdating(false);
  };

  const resetTableSetting = () => {
    setQueryParams({ limit: 20, offset: 0, currentPage: 1, forceTrigger: new Date() });
  };
  const handleNotificationAndViewDetail = () => {
    notification.destroy();
    setOpenConfiguredBinsDetailModel(true);
  };
  const notificationProps = {
    duration: 5,
    closeIcon: <div></div>,
    btn: (
      <Space>
        <ANTButton type='link' size='small' onClick={() => notification.destroy()}>
          Close
        </ANTButton>
        <ANTButton size='small' onClick={handleNotificationAndViewDetail}>
          Show Details
        </ANTButton>
      </Space>
    ),
  };
  const onAddSubmit = async (value) => {
    try {
      setIsBinAdding(true);
      if (binConfigType === 'csv') {
        const data = await handleBinConfigByFileData(selectedCSVFile);
        if (data?.length > 0) {
          try {
            const response = await addBinDiscountByCSVFile(store?._id, data);
            resetTableSetting();
            handleCloseModal();
            setConfiguredBinsDetailData(response?.data?.data);
            if (response?.data?.data?.binsDetailsNotFound?.length > 0 || response?.data?.data?.duplicateBINSData?.length > 0) {
              notification.info({
                message: 'Bins have been successfully added but there are some duplicate bins or bin details are not found against some bins.',
                placement: 'bottomRight',
                ...notificationProps,
              });
            } else {
              notification.success({ message: 'ALL BINS ADDED SUCCESSFULLY', placement: 'bottomRight', ...notificationProps });
            }
          } catch (err) {
            if (err?.response?.data?.error) {
              handleCloseModal();
              setConfiguredBinsDetailData(err.response.data.error);
              notification.error({
                message: err?.response?.data?.message,
                placement: 'bottomRight',
                ...notificationProps,
              });
            } else {
              hiddenFileInput.current.value = '';
              notification.error({
                message: err?.response?.data?.message,
                placement: 'bottomRight',
              });
            }
          }
        } else {
          notification.error({ message: 'Please enter valid data file', placement: 'bottomRight' });
        }
      } else {
        // const { start_date, end_date } = handleDiscountRangeFormat(discountDateRange);
        const payload = {
          bin: value?.bin,
          id: value?.id,
          discount_type: addBinDiscountType,
          discount_value: value?.discount_value,
          // start_date: start_date,
          // end_date: end_date,
          rule_enabled: addStatusToggle,
          ...(addBinDiscountType === 'percentage' && { discount_limit: value?.discount_limit }),
          minimum_order_value: value?.minimum_order_value,
          active_days: value?.active_days?.length > 0 ? value.active_days.join(',') : null,
          max_daily_usage: value?.usage_limits?.find((l) => l?.interval === 'daily')?.max_usage || null,
          max_monthly_usage: value?.usage_limits?.find((l) => l?.interval === 'monthly')?.max_usage || null,
        };
        const response = await addBinDiscount(store?._id, payload);
        if (response?.data?.success) {
          resetTableSetting();
          handleCloseModal();
        }
      }
    } catch (err) {
      console.log('catch error : ', err);
    }
    setIsBinAdding(false);
  };
  const handleCSVUploadClick = (event) => {
    hiddenFileInput.current.click();
  };
  const handleCSVFileUpload = (e) => {
    const fileData = e.target.files[0];
    if (fileData.type === 'text/csv' || fileData.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
      setSelectedCSVFile(fileData);
    } else {
      notification.error({ message: 'Please upload excel or csv file', placement: 'bottomRight' });
    }
  };

  const breadcrumbProps = {
    breadcrumbs: [
      {
        name: 'XPay',
        href: '/xpay',
      },
      {
        name: 'Account Settings',
      },
      {
        name: 'Bin Discount',
      },
    ],
  };
  return (
    <div className='binDiscountConatiner'>
      <div>
        <div className='header-container' style={{ paddingBottom: '1rem' }}>
          <div>
            <Breadcrumbs {...breadcrumbProps} />
          </div>
          <div className='headerPage header-mobile'>
            <div>
              <PageHeader label='Bin Discounts' button={<ResetButton onClick={isRefetching ? '' : refetch} loading={isRefetching} />} />
            </div>
            <div className='flexStoreFields m-r-10'>
              {/* <SelectStore onChange={handleOnStoreChange} setDefault={true} /> */}
              {checkUserPermissions([USER_ROLES.XPAY_ADMIN, USER_ROLES.XPAY_RESTRICTED_ADMIN]) && (
                <Button className='button-theme add-btn rounded-lg' onClick={() => setIsAddBinFormOpen(true)}>
                  Add BIN
                </Button>
              )}
            </div>
          </div>
        </div>
        <br />
        <div className='overflow-x-auto custom-table'>
          <Table
            loading={isLoading}
            dataSource={data?.docs || null}
            columns={columnsData}
            totalLenght={data?.totalDocs || 0}
            pagingation={{ handlePageChange: handlePagination, perPageSize: queryParams?.limit, page: queryParams?.currentPage }}
          />
        </div>
      </div>
      <Modal className='bin-modal custom-modal' width={400} destroyOnClose open={isAddBinFormOpen} onCancel={handleAddCloseModal} footer={null}>
        <div className='mobileModal'>
          <header className='font-[575] text-base text-[#262626] mb-4 mt-2'>Add BIN Discount</header>
          <AddBinDiscountForm
            options={options}
            fileUploadOptions={fileUploadOptions}
            onAddSubmit={onAddSubmit}
            setBinConfigType={setBinConfigType}
            binConfigType={binConfigType}
            hiddenFileInput={hiddenFileInput}
            setSelectedCSVFile={handleCSVFileUpload}
            handleCSVUploadClick={handleCSVUploadClick}
            selectedCSVFile={selectedCSVFile}
            addBinDiscountType={addBinDiscountType}
            setAddBinDiscountType={setAddBinDiscountType}
            handleCloseModal={handleAddCloseModal}
            dateRangeValue={discountDateRange}
            handleDiscountDateRange={handleDiscountDateRange}
            addStatusToggle={addStatusToggle}
            setAddStatusToggle={setAddStatusToggle}
            isBinAdding={isBinAdding}
          />
        </div>
      </Modal>
      <Modal
        className='bin-modal'
        open={deleteBinModal}
        width={400}
        onCancel={() => {
          setDeleteBinModal(false);
        }}
        footer={false}
        okButtonProps={{ loading: isBinDeleting }}
        destroyOnClose>
        <header className='font-semibold text-base mb-4'>Delete BIN</header>
        <div className='mb-8'>
          Are you sure you want to delete this BIN <span class='font-bold'>{'?'}</span>
        </div>
        <div className='flex mt-4'>
          <Button
            onClick={() => {
              setDeleteBinModal(false);
            }}
            block
            className='rounded-lg bg-plain'>
            Cancel
          </Button>
          <Button className='DeleteBtn ml-4 rounded-lg' block onClick={() => handleDeleteBin(binStoreId)} loading={isBinDeleting}>
            Confirm
          </Button>
        </div>
      </Modal>
      <Modal className='bin-modal custom-modal' destroyOnClose width={400} open={isBinModalOpen} onCancel={handleEditCloseModal} footer={null}>
        <div className='mobileModal mt-3'>
          <header className='font-semibold text-base mb-6'>Edit BIN Discount</header>
          <EditBinDiscountForm
            options={options}
            binModalData={binModalData}
            initialValues={initialValues}
            onSubmit={onUpdateSubmit}
            discountType={discountType}
            setDiscountType={setDiscountType}
            handleCloseModal={handleEditCloseModal}
            handleDelete={handleDeleteBin}
            dateRangeValue={discountDateRange}
            handleDiscountDateRange={handleDiscountDateRange}
            statusToggle={statusToggle}
            setStatusToggle={setStatusToggle}
            isBinDeleting={isBinDeleting}
            isBinUpdating={isBinUpdating}
          />
        </div>
      </Modal>
      <div>
        <Modal
          title='Details of Bins Configuration by File'
          centered
          width={400}
          className='csvBINSModal'
          open={openConfiguredBinsDetailModel}
          destroyOnClose
          footer={null}
          onOk={() => setOpenConfiguredBinsDetailModel(false)}
          onCancel={() => setOpenConfiguredBinsDetailModel(false)}>
          <CSVBinsModel data={configuredBinsDetailData} />
        </Modal>
      </div>
    </div>
  );
};

const EditBinDiscountForm = ({
  options,
  binModalData,
  statusToggle,
  setDiscountType,
  setStatusToggle,
  onSubmit,
  initialValues,
  discountType,
  handleCloseModal,
  isBinUpdating,
  handleDelete,
  isBinDeleting,
  dateRangeValue,
  handleDiscountDateRange,
}) => {
  const [form] = Form.useForm();
  const watchedLimits = Form.useWatch('usage_limits', form) || [];
  const selectedIntervals = watchedLimits.map((l) => l?.interval).filter(Boolean);
  return (
    <Form form={form} layout='vertical' onFinish={onSubmit} initialValues={initialValues}>
      <div>
        <h2 className='font-bold text-base'>Bank Name</h2>
        <p>{binModalData?.bank_name}</p>
      </div>
      <div className='mt-[12px]'>
        <Form.Item className='modal-field selectorWidth' label='Discount Type'>
          <Select defaultValue={discountType} optionsValue={options} handleChange={(e) => setDiscountType(e.value)} />
        </Form.Item>
        {/* <Form.Item name='date_range' className='mb-[30px]' label='Discount Applicable Date Range:'>
          <RangePicker onChange={handleDiscountDateRange} name='date_range' value={dateRangeValue} disabledDate={(current) => current.isBefore(moment().add(-1, 'days'))} />
        </Form.Item> */}

        {discountType === 'percentage' ? (
          <div className='-mt-[12px]'>
            <Form.Item
              className='modal-field'
              name='discount_value'
              label='Value'
              rules={[
                {
                  required: true,
                  message: 'Value is required',
                },
                {
                  max: 2,
                  message: 'Value must be less then 100%',
                },
                {
                  message: 'Only positive numbers allowed',
                  validator: (_, value) => {
                    if (!value) return Promise.resolve();
                    if (/^\d+$/.test(value)) {
                      return Promise.resolve();
                    } else {
                      return Promise.reject('Invalid Discount Value');
                    }
                  },
                },
              ]}>
              <Input type='number' min='1' placeholder='Enter Percentage' onKeyUp={handelValue} name='discount_value' />
            </Form.Item>
            <div className='-mt-[12px] bin-container'>
              <Form.Item
                name='discount_limit'
                label='Discount Limit'
                className='modal-field'
                rules={[
                  {
                    min: 1,
                    message: 'Minimum value must be 1',
                  },
                  {
                    message: 'Only positive numbers allowed',
                    validator: (_, value) => {
                      if (!value) return Promise.resolve();
                      if (/^[0-9]+$/.test(value)) {
                        return Promise.resolve();
                      } else {
                        return Promise.reject('Invalid Discount Limit');
                      }
                    },
                  },
                ]}>
                <Input min='1' type='number' placeholder='Enter Limit' onKeyUp={handelValue} name='discount_limit' />
              </Form.Item>
            </div>
          </div>
        ) : discountType === 'value' ? (
          <div className='-mt-[12px] bin-container'>
            <Form.Item
              name='discount_value'
              label='Value'
              className='modal-field'
              rules={[
                {
                  required: true,
                  message: 'Value is required',
                },
                {
                  min: 1,
                  message: 'Minimum value must be 1',
                },
                {
                  message: 'Only positive numbers allowed',
                  validator: (_, value) => {
                    if (!value) return Promise.resolve();
                    if (/^[0-9]+$/.test(value)) {
                      return Promise.resolve();
                    } else {
                      return Promise.reject('Invalid Discount Value');
                    }
                  },
                },
              ]}>
              <Input type='number' min='1' placeholder='Enter value' onKeyUp={handelValue} name='discount_value' />
            </Form.Item>
          </div>
        ) : null}
      </div>
      <div className='mt-[12px]'>
        <Form.Item
          className='modal-field'
          name='id'
          label='Custom Id'
          rules={[
            {
              message: 'Value contains invalid special characters',
              validator: (_, value) => {
                if (!value) return Promise.resolve();
                if (/^[^%?!{}[\]$^*@<>]*$/.test(value)) {
                  return Promise.resolve();
                } else {
                  return Promise.reject('Invalid Custom Id');
                }
              },
            },
          ]}>
          <Input placeholder='Enter custom id' />
        </Form.Item>
      </div>
      <div className='mt-[12px]'>
        <Form.Item
          className='modal-field'
          name='minimum_order_value'
          label='Minimum Order Value'
          rules={[
            {
              validator: (_, value) => {
                if (!value) return Promise.resolve();
                if (/^[1-9][0-9]*$/.test(value)) return Promise.resolve();
                return Promise.reject('Only positive numbers allowed');
              },
            },
          ]}>
          <Input type='number' min='1' placeholder='Enter minimum order value' />
        </Form.Item>
      </div>
      <div className='mt-[12px]'>
        <Form.Item className='modal-field' name='active_days' label='Discount Days'>
          <AntSelect mode='multiple' placeholder='Select allowed days' allowClear maxTagCount='responsive'>
            {['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'].map((day) => (
              <AntSelect.Option key={day} value={day}>
                {day.charAt(0).toUpperCase() + day.slice(1)}
              </AntSelect.Option>
            ))}
          </AntSelect>
        </Form.Item>
      </div>
      <div className='mt-[12px]'>
        <Form.List name='usage_limits'>
          {(fields, { add, remove }) => (
            <div>
              <div className='flex items-center justify-between'>
                <label className='text-sm font-medium'>Frequency</label>
                {fields?.length < 2 && (
                  <div className='mt-2'>
                    <PlusCircleOutlined onClick={() => add()} style={{ fontSize: 18, cursor: 'pointer' }} />
                  </div>
                )}
              </div>
              {fields.map(({ key, name, ...restField }) => (
                <div key={key} className='flex items-center gap-2 mt-2'>
                  <Form.Item {...restField} name={[name, 'interval']} className='mb-0 flex-shrink-0' rules={[{ required: true, message: 'Select interval' }]}>
                    <AntSelect placeholder='Interval' style={{ width: 110 }}>
                      <AntSelect.Option value='daily' disabled={selectedIntervals.some((s, i) => s === 'daily' && i !== name)}>
                        Daily
                      </AntSelect.Option>
                      <AntSelect.Option value='monthly' disabled={selectedIntervals.some((s, i) => s === 'monthly' && i !== name)}>
                        Monthly
                      </AntSelect.Option>
                    </AntSelect>
                  </Form.Item>
                  <Form.Item
                    {...restField}
                    name={[name, 'max_usage']}
                    className='mb-0 flex-1'
                    rules={[
                      { required: true, message: 'Required' },
                      {
                        validator: (_, value) => {
                          if (!value) return Promise.resolve();
                          if (/^[1-9][0-9]*$/.test(value)) return Promise.resolve();
                          return Promise.reject('Only positive numbers allowed');
                        },
                      },
                    ]}>
                    <Input type='number' min='1' placeholder='Max usage' />
                  </Form.Item>
                  <MinusCircleOutlined onClick={() => remove(name)} style={{ fontSize: 18, color: '#ff4d4f', flexShrink: 0 }} />
                </div>
              ))}
            </div>
          )}
        </Form.List>
      </div>
      {/* <div className='flex items-cente justify-between'>
        <div className='mb-[30px]'>
          <Form.Item name='rule_enabled' className='font-bold mb-[30px]' label='Rule Enabled:'>
            <Switch checked={statusToggle} onClick={() => setStatusToggle(!statusToggle)} name='rule_enabled' />
          </Form.Item>
        </div>
      </div> */}
      <div className='mt-[30px]'>
        <Form.Item>
          <div className='mb-[-24px]'>
            <div className='flex'>
              <ANTButton className='rounded-lg' block onClick={() => handleCloseModal()}>
                Cancel
              </ANTButton>
              <Button block className='button-theme rounded-lg ml-4' htmlType='submit' disabled={isBinUpdating} loading={isBinUpdating}>
                Update
              </Button>
            </div>
            {/* <Popconfirm
              title={
                <div>
                  Are you sure you want to delete this BIN{' '}
                  <span class='font-bold'>
                    {binModalData?.bin}
                    {'?'}
                  </span>
                </div>
              }
              okButtonProps={{ loading: isBinDeleting }}
              onConfirm={() => handleDelete(binModalData?._id)}
              okText='Yes'
              cancelText='No'
              placement='topRight'
              getPopupContainer={(trigger) => trigger.parentNode}>
              <Button type='primary'>Delete</Button>
            </Popconfirm> */}
          </div>
        </Form.Item>
      </div>
    </Form>
  );
};

const AddBinDiscountForm = ({
  options,
  addStatusToggle,
  fileUploadOptions,
  hiddenFileInput,
  setSelectedCSVFile,
  handleCSVUploadClick,
  selectedCSVFile,
  addBinDiscountType,
  setAddBinDiscountType,
  setAddStatusToggle,
  setBinConfigType,
  binConfigType,
  onAddSubmit,
  handleCloseModal,
  isBinAdding = false,
  dateRangeValue,
  handleDiscountDateRange,
}) => {
  const [form] = Form.useForm();
  const watchedLimits = Form.useWatch('usage_limits', form) || [];
  const selectedIntervals = watchedLimits.map((l) => l?.interval).filter(Boolean);
  return (
    <Form form={form} layout='vertical' onFinish={onAddSubmit}>
      <div className='mt-[30px]'>
        <Form.Item className='modal-field selectorWidth' label='Configuration Type'>
          <Select optionsValue={fileUploadOptions} handleChange={(e) => setBinConfigType(e.value)} />
        </Form.Item>
      </div>
      {binConfigType === 'csv' ? (
        <div className='mb-[30px]'>
          <ANTButton className='uploadBinsBtn rounded-lg' onClick={handleCSVUploadClick} icon={<UploadOutlined style={{ fontSize: '16px' }} />}>
            Upload CSV File
          </ANTButton>
          <p style={{ marginTop: 'auto', marginBottom: 'auto', marginLeft: '10px', color: 'blue' }}>{selectedCSVFile?.name ?? ''}</p>
          <input type='file' accept='.csv' ref={hiddenFileInput} onChange={setSelectedCSVFile} style={{ display: 'none' }} />
          <div style={{ display: 'flex', marginTop: '8px' }}>
            <p style={{ margin: '0px' }}>Please download the template file by clicking </p>
            <a href='https://xap.xstak.com/bulk-bin-template-file.csv' target={'_blank'} style={{ color: 'blue', marginLeft: '4px', textDecoration: 'underline', cursor: 'pointer' }}>
              here
            </a>
          </div>
        </div>
      ) : (
        <>
          <div className='-mt-[12px]'>
            <Form.Item
              className='modal-field'
              name='bin'
              label='BIN'
              rules={[
                {
                  required: true,
                  message: 'BIN is required',
                },
                {
                  validator: (_, value) => {
                    if (!value) return Promise.resolve();
                    if (!/^\d+$/.test(value)) {
                      return Promise.reject('BIN must contain only digits');
                    }
                    if (value?.length !== 6 && value?.length !== 8) {
                      return Promise.reject('BIN must contain exactly 6 or 8 digits');
                    }
                    return Promise.resolve();
                  },
                },
              ]}>
              <Input type='number' min='0' placeholder='Enter BIN' onKeyUp={handelValue} name='bin' />
            </Form.Item>
          </div>
          <div className='-mt-[12px]'>
            <Form.Item className='modal-field selectorWidth' label='Discount Type'>
              <Select defaultValue={addBinDiscountType} optionsValue={options} handleChange={(e) => setAddBinDiscountType(e.value)} />
            </Form.Item>
            {/* <Form.Item name='discount_type' className='mb-[30px]' label='Discount Applicable Date Range:'>
              <RangePicker onChange={handleDiscountDateRange} value={dateRangeValue} disabledDate={(current) => current.isBefore(moment().add(-1, 'days'))} />
            </Form.Item> */}

            {addBinDiscountType === 'percentage' ? (
              <div className='-mt-[12px]'>
                <Form.Item
                  name='discount_value'
                  label='Value'
                  className='modal-field'
                  rules={[
                    {
                      required: true,
                      message: 'Value is required',
                    },
                    {
                      max: 2,
                      message: 'Value must be less then 100%',
                    },
                    {
                      message: 'Only positive numbers allowed',
                      validator: (_, value) => {
                        if (!value) return Promise.resolve();
                        if (/^[0-9]+$/.test(value)) {
                          return Promise.resolve();
                        } else {
                          return Promise.reject('Invalid Discount Value');
                        }
                      },
                    },
                  ]}>
                  <Input type='number' min='1' placeholder='Enter Percentage' onKeyUp={handelValue} name='discount_value' />
                </Form.Item>
                <div className='-mt-[12px]'>
                  <Form.Item
                    name='discount_limit'
                    label='Discount Limit'
                    className='modal-field'
                    rules={[
                      {
                        min: 1,
                        message: 'Minimum value must be 1',
                      },
                      {
                        message: 'Only positive numbers allowed',
                        validator: (_, value) => {
                          if (!value) return Promise.resolve();
                          if (/^[0-9]+$/.test(value)) {
                            return Promise.resolve();
                          } else {
                            return Promise.reject('Invalid Discount Limit');
                          }
                        },
                      },
                    ]}>
                    <Input type='number' min='1' placeholder='Enter Limit' onKeyUp={handelValue} name='discount_limit' />
                  </Form.Item>
                </div>
              </div>
            ) : addBinDiscountType === 'value' ? (
              <>
                <Form.Item
                  name='discount_value'
                  label='Value'
                  className='modal-field  -mt-[12px]'
                  rules={[
                    {
                      required: true,
                      message: 'Value is required',
                    },
                    {
                      message: 'Only positive numbers allowed',
                      validator: (_, value) => {
                        if (!value) return Promise.resolve();
                        if (/^[0-9]+$/.test(value)) {
                          return Promise.resolve();
                        } else {
                          return Promise.reject('Invalid Discount Value');
                        }
                      },
                    },
                  ]}>
                  <Input type='number' min='1' placeholder='Enter value' onKeyUp={handelValue} name='discount_value' />
                </Form.Item>
              </>
            ) : null}
          </div>
          <div className='-mt-[12px]'>
            <Form.Item
              className='modal-field'
              name='id'
              label='Custom Id'
              rules={[
                {
                  message: 'Value contains invalid special characters',
                  validator: (_, value) => {
                    if (!value) return Promise.resolve();
                    if (/^[^%?!{}[\]$^*@<>]*$/.test(value)) {
                      return Promise.resolve();
                    } else {
                      return Promise.reject('Invalid Custom Id');
                    }
                  },
                },
              ]}>
              <Input placeholder='Enter custom id' />
            </Form.Item>
          </div>
          <div className='-mt-[12px]'>
            <Form.Item
              className='modal-field'
              name='minimum_order_value'
              label='Minimum Order Value'
              rules={[
                {
                  validator: (_, value) => {
                    if (!value) return Promise.resolve();
                    if (/^[1-9][0-9]*$/.test(value)) return Promise.resolve();
                    return Promise.reject('Only positive numbers allowed');
                  },
                },
              ]}>
              <Input type='number' min='1' placeholder='Enter minimum order value' />
            </Form.Item>
          </div>
          <div className='-mt-[12px]'>
            <Form.Item className='modal-field' name='active_days' label='Discount Days'>
              <AntSelect mode='multiple' placeholder='Select allowed days' allowClear maxTagCount='responsive'>
                {['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'].map((day) => (
                  <AntSelect.Option key={day} value={day}>
                    {day.charAt(0).toUpperCase() + day.slice(1)}
                  </AntSelect.Option>
                ))}
              </AntSelect>
            </Form.Item>
          </div>
          <div className='-mt-[12px]'>
            <Form.List name='usage_limits'>
              {(fields, { add, remove }) => (
                <div>
                  <div className='flex items-center justify-between'>
                    <label className='text-sm font-medium'>Frequency</label>
                    {fields.length < 2 && (
                      <div className='mt-2'>
                        <PlusCircleOutlined onClick={() => add()} style={{ fontSize: 18, cursor: 'pointer' }} />
                      </div>
                    )}
                  </div>
                  {fields.map(({ key, name, ...restField }) => (
                    <div key={key} className='flex items-center justify-between gap-2 mt-1'>
                      <Form.Item {...restField} name={[name, 'interval']} className='mb-0 flex-shrink-0' rules={[{ required: true, message: 'Select interval' }]}>
                        <AntSelect placeholder='Interval' style={{ width: 100 }}>
                          <AntSelect.Option value='daily' disabled={selectedIntervals.some((s, i) => s === 'daily' && i !== name)}>
                            Daily
                          </AntSelect.Option>
                          <AntSelect.Option value='monthly' disabled={selectedIntervals.some((s, i) => s === 'monthly' && i !== name)}>
                            Monthly
                          </AntSelect.Option>
                        </AntSelect>
                      </Form.Item>
                      <Form.Item
                        {...restField}
                        name={[name, 'max_usage']}
                        className='mb-0 flex-1'
                        rules={[
                          { required: true, message: 'Required' },
                          {
                            validator: (_, value) => {
                              if (!value) return Promise.resolve();
                              if (/^[1-9][0-9]*$/.test(value)) return Promise.resolve();
                              return Promise.reject('Only positive numbers allowed');
                            },
                          },
                        ]}>
                        <Input type='number' min='1' placeholder='Max usage' />
                      </Form.Item>
                      <MinusCircleOutlined onClick={() => remove(name)} style={{ fontSize: 18, color: '#ff4d4f', flexShrink: 0 }} />
                    </div>
                  ))}
                </div>
              )}
            </Form.List>
          </div>
          <div className='-mt-[2px] '>
            <div className='custom-switch flex'>
              <Form.Item name='rule_enabled' className='modal-field'>
                <label className='mr-6'>Enable Rule</label>
                <Switch checked={addStatusToggle} onClick={() => setAddStatusToggle(!addStatusToggle)} name='rule_enabled' />
              </Form.Item>
            </div>
          </div>
        </>
      )}
      <div className='mb-[-20px]'>
        <Form.Item>
          <div style={{ display: 'flex' }}>
            <ANTButton block className='rounded-lg' onClick={() => handleCloseModal()}>
              Cancel
            </ANTButton>
            <Button block className='button-theme ml-4 rounded-lg' htmlType='submit' loading={isBinAdding}>
              Add
            </Button>
          </div>
        </Form.Item>
      </div>
    </Form>
  );
};
